import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Witbooking**
 *
 * Official: www.witbooking.com
 *
 * Example: <a href="https://engine.witbooking.com/hostalgrau.com/availability" target="_blank">Hostal Grau</a>
 *
 * @exports bs_1
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const HOTEL_SAULO_PID = 1028121;

  /**
     * @memberOf module:bs_1
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    const userLogged = (document.querySelector('.sta-menus-air_nav-morebtns-element') || {}).href;
    const supportsLocalStorage = thn.supports('local_storage');
    return !!(
      (userLogged && userLogged.match(/my-booking/))
      || document.querySelector('.bar-client.active')
      || (supportsLocalStorage && window.localStorage.getItem('SESSION_ID'))
    );
  };

  /**
     * @memberOf module:bs_1
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      let lang;
      const witbookerParams = window.witbookerParams;

      // PID: 1049582
      if (thn.data.propertyId === 1049582 && window.location.host.match(/hotelturin\.com/)) {
        lang = document.querySelector('.btn-idioma button')?.textContent.toLocaleLowerCase().trim();
        resolve(lang);
        return;
      }

      // Get it from the HTML lang tag
      lang = document.getElementsByTagName('html')[0].getAttribute('lang');
      if (lang && [1011767, 1021854, 1037972].includes(thn.data.accountUserId)) {
        lang = lang.toLowerCase().trim().substr(0, 2);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if (window.location.hostname.match(/reservations.hqrooms/) && !document.querySelector('.row.Dropdown--Header')) {
        lang = window.location.pathname.match(/\/\w{2}\//)?.[0]?.replace(/\//g, '');
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if (witbookerParams
        && witbookerParams.representation
        && witbookerParams.representation.locale
        && ctx.langs.test(witbookerParams.representation.locale)) {
        resolve(witbookerParams.representation.locale);
        return;
      }

      // Works for the Homepage and the BE
      if (window.location.host.match(/doncarlosresort\.com/)) {
        lang = ((document.querySelector('.wpml-ls-native, .row.dropdown .Dropdown--Header div:nth-child(2), .acordeon_idioma') || []).textContent || 'en').toLowerCase();
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      lang = window.location.pathname.match(ctx.urlRe);
      if (lang && ctx.langs.test(lang[1])) {
        resolve(lang[1]);
        return;
      }

      lang = thn.parseUrlParameter('lang');
      if (lang === 'ch') {
        lang = 'zh';
        resolve(lang);
      }
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      // PID: 1000348
      if (window.idiomaWeb) {
        lang = window.idiomaWeb;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if (thn.data.hotelId === 1035295) {
        resolve('es');
        return;
      }

      thn.domReady().then(function () {

        var head = document.querySelectorAll('.row.Dropdown--Header');

        if (head && head.length === 2) {
          if (head[1].querySelector('span[alt]')) {
            lang = head[1].querySelector('span[alt]').getAttribute('alt').toLowerCase();
            if (lang && ctx.langs.test(lang)) {
              resolve(lang);
              return;
            }
          }

        }

        reject('no_language');

      }); // on domReady

    });
  };

  /**
     * @memberOf module:bs_1
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = /^(engine|reservation|reservas)/.test(url.host) && (/\/availability\/?$/).test(url.pathname);
    if (validUrl) {
      // https://reservations.alandamarbellahotel.com/alandahotelmarbella.com/availability?datein=11-01-2023&dateout=12-01-2023&adultos=2&ninos=0&prom=BLACKFRIDAY&lang=es&_ga=2.158966200.348168980.1669651032-583310705.1669651031
      url.searchParams.set('datein', '[date_begin]');
      url.searchParams.set('dateout', '[date_end]');
      url.searchParams.set('adultos', '[adults]');
      url.searchParams.set('ninos', '[children]');
      url.searchParams.set('lang', '[language]');
      url.searchParams.set('prom', '');

      // adapt url to language
      // https://reservation.mhapartments.com/mh_centralmadrid/fr/availability?datein=21-11-2023&dateout=23-11-2023&adultos=1&ninos=0&lang=es&prom=
      url.pathname = url.pathname.replace(/\/\w{2}\//, '/[language]/');

      // export into ctx.new_url
      ctx.newUrl = url.toString();

      ctx.newData.dateBegin = (ctx.newData?.dateBegin || ctx.data?.dateBegin)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
      ctx.newData.dateEnd = (ctx.newData?.dateEnd || ctx.data?.dateEnd)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');

    } else {
      // This is not a valid URL
      ctx.newUrl = '';
    }

    return ctx;
  };

  /**
     * @memberOf module:bs_1
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {

    if (thn.data.propertyId === 1000432 && thn.data.pageName === 'Index') {
      setTimeout(thn.languageCheck, 400);
    }

    if (thn.widgets.price.isVisible()) {
      thn.widgets.price.destroy();
    }

    setTimeout(thn.pageCheck, 400);
  };

  /**
     * @memberOf module:bs_1
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {
    const container = document.querySelector('[class*=StickyContainer]') || document.querySelector('#content');
    if (container) {
      const refreshPage = thn.debounce(() => {
        thn.pageCheck();
        thn.languageCheck();
        // There are cases where we do not want to refresh to avoid the PW appearing in the information tab of a room.
        const wantsToRefresh = ![1033906, 1001714, 1034881, 1035410].includes(thn.data.accountUserId) && !thn.parseUrlParameter('expand');
        if (thn.data.pageName === 'Rooms and Rates' && wantsToRefresh) {
          thn.widgets.price.refresh();
        }
      }, 400);

      thn.observeDom(container, refreshPage, {
        childList: true,
        subtree: true,
        attributes: false,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(container, refreshPage);
      });

    }
  };

  /**
     * @memberOf module:bs_1
     * @see {@link onHashChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onHashChange = function onHashChange(ctx) {

    if (window.location.hash.match(/stepTwo/i)) {
      thn.widgets.price.remove();
    }
  };

  /**
     * @memberOf module:bs_1
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    var modal;
    var container;
    var classes;

    // defensive
    ctx.widget.remove();

    // Early exit
    if (thn.data.witbookingInitialized) {
      return;
    }

    thn.witbookingUpdate = function thnWitbookingUpdate(mutations) {
      // Early exit
      if (!mutations || !mutations.length) {
        return;
      }

      classes = Array.from(mutations[0].target.classList).filter(function (name) {
        return !name.match(/^wbk(v9)?-|^fullWidthMode$/i);
      });

      // if more than one class, then it is loading ...
      if (classes.length > 1) {
        ctx.widget.minimize();
        // if only one class, then loading finished
      } else if (classes.length === 1) {
        // remember to languageCheck
        setTimeout(function () {
          thn.languageCheck().then(function ({ changed }) {
            if (!changed) {
              if (thn.data.propertyId === HOTEL_SAULO_PID) {
                thn.pageCheck({ force: true });
              } else if (thn.data.pageName !== 'User Register Page') {
                ctx.widget.update();
              }
            }
          });
        }, 400);
      }
    };

    // observe #availability for class changes
    // normal state: has 1 class, loading: has 2 classes
    // when it changes classes, then it means something is "loading" or
    // has just finished "loading"
    //
    container = document.getElementById('availability');
    if (container) {
      thn.observeDom(container, thn.witbookingUpdate, {
        childList: false,
        subtree: false,
        characterData: false,
        attributes: true,
        attributeFilter: ['class'],
      });
      thn.pageUnload(function () {
        thn.stopObserveDom(container, thn.witbookingUpdate);
      });
    }

    // Some hotels has filter to show normal rooms or packages
    const filterWrapperParent = document.querySelector('#innerContainer > div > div:nth-child(2)');
    const loader = thn.isVisible(document.querySelector('.wbkv9-Loader-loader'));
    // The filter wrapper is deteled each time we change the filter, for that reason we select the parent element
    // Check if the filter exists, if exists,select the parent element. (and check if we selected the correct element)
    if (filterWrapperParent && filterWrapperParent.querySelector('[class*="FilterTab-wrapper"]')) {
      if (!thn.witbookingFilterUpdate && !loader) {
        thn.witbookingFilterUpdate = function thnWitbookingFilterUpdate() {
          setTimeout(() => ctx.widget.refresh(), 300);
          thn.pageCheck();
        };
      }

      thn.observeDom(filterWrapperParent, thn.witbookingFilterUpdate, {
        childList: true,
        subtree: true,
        characterData: false,
        attributes: true,
        attributeFilter: ['class'],
      });
      thn.pageUnload(function () {
        thn.stopObserveDom(filterWrapperParent, thn.witbookingFilterUpdate);
        delete thn.witbookingFilterUpdate;
      });
    }

    // when modal dialog triggers hide the widget
    modal = document.getElementById('modi');
    if (modal) {
      thn.observeDom(modal, ctx.widget.minimize);
      thn.pageUnload(function () {
        thn.stopObserveDom(modal, ctx.widget.minimize);
      });
    }

    // click on the currency selector
    // Note we use 'mouseup' cause 'click' bubbling is cancelled by the BE
    const undelegateWbk = thn.delegate('mouseup', '.wbk-Dropdown.row.dropdown:first-child .Dropdown--Overlay > div', function () {
      ctx.widget.logger.debug('Click on currency');
      setTimeout(() => ctx.widget.refresh(), 200);
    });

    // 2018-10-19: New currency observer for version v9
    const undelegateWbkv9 = thn.delegate('mouseup', '.wbkv9-Dropdown.row.dropdown:first-child .Dropdown--Overlay > div', function () {
      ctx.widget.logger.debug('Click on currency (v9)');
      setTimeout(() => ctx.widget.refresh(), 200);
    });

    thn.data.witbookingInitialized = true;
    this.logger.debug('************** WitBooking Initialized *****************');

    thn.pageUnload(function () {
      undelegateWbk();
      undelegateWbkv9();
      delete thn.data.witbookingInitialized;
      delete thn.witbookingUpdate;
    });
  };

  /**
     * Implements **noRooms**.
     *
     * No Rooms setted true when selected search does not find rooms
     * for selected guests even showing different kind of rooms.
     *
     * @memberOf module:bs_1
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData_v1(ctx) {

    const widgetData = {};

    // Is old Witbooking version?
    if (window.dataLayer && thn.dataLayerHelper.get('FunnelVirtualPage')) {
      return widgetData;
    }

    thn.logger.debug('--- Witbooking old version ---');

    const selector = '.available .Amount';
    let prices = document.querySelectorAll(selector);
    const noRooms = document.querySelector('#innerContainer .wbk-Notification--warning')
      || document.querySelector('div[class*=AvailabilityNotification] span[class*=Notification-content]')
      || document.querySelector('div[class*=MessageOverlay] div[class*=Loader]')
      // Error shown when the user a date range lower than the minimum than the hotel has
      || document.querySelector('[class*="BookableErrorMessage"]')
      || document.querySelector('#TOP_INVENTORY_STEP_1_NO_RESULTS');
    const head = document.querySelectorAll('.row.Dropdown--Header');
    const children = document.querySelector('select[name=CHILD]');
    const dates = document.querySelectorAll('.InputDate-date');
    let nights;
    let guessCurrency;

    // 2019-03-27: If "expand" exists in the query string, we must check what page are we in
    // If a booking button class exists, then we're visiting a particular rate and the priceSpecial flag must be set to 1
    // Otherwise, we could've come from the general "Select Hotel" page and now be in the R&R page. That's correct, no priceSpecial flag needed
    /*
            2019-05-13 add condition for chic & basic hotels
            check if il_like or il_equal parameters exist, this means we are using specific room filter
            OTAs will compare the selected room against the cheapest price obtained
        */
    const bookingButtonClass = document.querySelectorAll('.wbkv9-InventoryRates-bookNowButton');
    if ((!thn.empty(thn.parseUrlParameter('expand')) && (bookingButtonClass && bookingButtonClass.length))
      || (thn.data.accountUserId === 1021854 && (thn.parseUrlParameter('il_like') || thn.parseUrlParameter('il_equal')))
      // Some hotels has a filter for packages, if the first filter is active, the user is seeing normal rooms
      || (document.querySelector('[class*="FilterTab-wrapper"]') && !document.querySelector('[class*="FilterTab-wrapper"] > [class*="FilterTab-element"].active:nth-child(1)'))) {
      this.logger.warn('Specific Rate Page! Price Special flag enabled.');
      widgetData.priceSpecial = 1;
    } else {
      // Reset flag (when switching between general and particular rates)
      widgetData.priceSpecial = 0;
    }

    // include language data to influence the refresh function
    widgetData.language = thn.data.language;

    if (head && head.length === 2) {
      const tmpCurrency = (head[1].textContent || '').slice(0, -1);
      if (tmpCurrency) {
        widgetData.currency = thn.getCurrencyCode(tmpCurrency);
      }
    } else if (thn.parseUrlParameter('currency') || thn.parseUrlParameter('setconversion')) {
      widgetData.currency = thn.parseUrlParameter('currency') || thn.parseUrlParameter('setconversion');
    } else if (prices.length) {
      guessCurrency = prices[0].previousSibling.textContent.match(/[A-Z]+/);
      if (guessCurrency) {
        widgetData.currency = guessCurrency[0];
      }
    }
    widgetData.guests = 0;
    const adultsByDropDown = document.querySelector('select[name=ADULT]');
    const adultsByParam = thn.parseUrlParameter('adults') || thn.parseUrlParameter('adultos');
    const adultsFirstValue = document.getElementsByClassName('wbk-OccupatnsWrapper-TotalOccupants');

    // check if param url and dropdown have the same value, otherwise it is not the way
    if (adultsByParam && adultsFirstValue.length && adultsByParam === adultsFirstValue[0].innerText) {
      widgetData.adults = parseInt(adultsByParam, 10) || 2;
    } else if (adultsByDropDown) {
      widgetData.adults = parseInt(adultsByDropDown.options[adultsByDropDown.selectedIndex].value, 10) || 2;
    } else {
      widgetData.adults = 2;
    }

    // Children
    if (children) {
      widgetData.children = parseInt(children.options[children.selectedIndex].value, 10) || 0;
    } else if (thn.parseUrlParameter('children') || thn.parseUrlParameter('ninos')) {
      widgetData.children = parseInt(thn.parseUrlParameter('children') || thn.parseUrlParameter('ninos'), 10) || 0;
    } else if (window.guestAges && window.guestAges.length) {
      // In some properties, like 1026625
      // We don't have any type or information that tells us the number of children in a clean way
      // In this case document.querySelector('select[name=childrenCount]').selectedIndex is always 0
      // A cool trick we can use is to count the ages of each children, this is the only reliave information
      // we have on the window object to obtain this data
      widgetData.children = window.guestAges.length;
    } else {
      widgetData.children = 0;
    }

    widgetData.guests = widgetData.adult + widgetData.children;

    // Dates
    if (dates && dates.length === 2) {
      widgetData.dateBegin = translateDate(dates[0].textContent, thn.data.language);
      widgetData.dateEnd = translateDate(dates[1].textContent, thn.data.language);

    } else if (thn.parseUrlParameter('fini')) {
      nights = parseInt(thn.parseUrlParameter('nights'), 10) || 1;
      // from dd-mm-yyyy to yyyy/mm/dd
      widgetData.dateBegin = thn.parseUrlParameter('fini').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, nights));

    } else if (thn.parseUrlParameter('datein') && thn.parseUrlParameter('dateout')) {
      // from dd-mm-yyyy to yyyy/mm/dd
      widgetData.dateBegin = thn.parseUrlParameter('datein').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = thn.parseUrlParameter('dateout').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

    }

    if (prices.length > 0) {
      // convert prices to array and map prices
      prices = Array.from(prices).map(function (el) {
        return parseFloat(`${el.children[0].textContent}.${el.children[1].textContent}`);
      });
    } else {
      prices = document.querySelectorAll('.wbkv9-Amount-integerPart, #innerContainer > div > div > div > div > div > div > span > span:nth-child(2)'); // random classes
      prices = Array.from(prices).map((el) => {
        let price = el.textContent;
        if (window.location.search.match(/ViewType=GRID/i)
          || !document.querySelector('[class*="integer"]')) {
          price = price.replace(/(..)$/, '.$1');
        }
        return parseFloat(price);
      });
      let thnCurrency = document.querySelector('.wbkv9-Entity-amountCurrencyLabel');
      if (!widgetData.currency && thnCurrency) {
        thnCurrency = thnCurrency.textContent.replace('/', '').split(' ');
        widgetData.currency = thn.parseCurrency(thnCurrency[1]);
      } if (!widgetData.currency) {
        widgetData.currency = window.configuration && window.configuration.currency;
      }
    }

    if (noRooms && !prices.length) {
      widgetData.noRooms = true;
    } else if (prices.length) {
      widgetData.price = Math.min(...prices);
      /** When selecting a room to see its rates, prices are displayed by stay.
            * A URL paramater is set, so check if it exists when the PW is triggered,
            * and divide by nights.
            * 2019-03-28: Also check if a "Book Now" button class exists, as we do at the beginning of this function.
            * NOTE: On Prop 1000351, though the URL parameter is set, the price is by night
            */
      if (thn.parseUrlParameter('expand')
        && thn.data.propertyId !== 1000351
        && (bookingButtonClass && bookingButtonClass.length)) {

        widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      }

      widgetData.set = true;
    }

    if (thn.data.propertyId === 1000598) { // El Corsario
      ctx.widget.data.bubbles = false;
    }

    return widgetData;
  };

  engine.priceParseData_v2 = function priceParseData_v2(ctx) {

    const widgetData = {};
    const isHotelCausingDisparityInRoomDetails = thn.data.accountUserId === 1034592 && window.location.search.includes('expand');
    // Is new version of Witbooking?
    // If yes, we should rely on the URL params, it will disapear once we change the data in the form
    // The HTML classes are pretty much obsfucated, but we can obtain the price
    // For dates and guests, we rely on the dataLayer
    if (!window.dataLayer || !thn.dataLayerHelper.get('FunnelVirtualPage') || isHotelCausingDisparityInRoomDetails) {
      return widgetData;
    }

    thn.logger.debug('--- Witbooking new version ---');

    // Some hotels has a filter for packages, if the first filter is active, the user is seeing normal rooms
    // On the first tab, we see the rooms and packages, on the second one rooms and the third one only packages
    const correctFilters = document.querySelector('[class*=-FilterTab-wrapper] > div:nth-child(1).active, [class*=-FilterTab-wrapper] > div:nth-child(2).active');
    // Also check if the page has filters
    if (document.querySelector('[class*=-FilterTab-wrapper]') && !correctFilters) {
      widgetData.priceSpecial = 1;
    }

    const filterTextDesktop = document.querySelector('[class*=FilterTab-element]');
    const filterTextMobile = document.querySelector('select[class*=FilterTab-selector]');

    if ((filterTextDesktop && !filterTextDesktop.classList.contains('active')) || (filterTextMobile && filterTextMobile.selectedIndex !== 0)) {
      widgetData.priceSpecial = 1;
    }

    // Dates
    const dateBegin = window.wbkStartDate?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') || (thn.dataLayerHelper.get('checkInDate') || thn.dataLayerHelper.get('checkin_date') || '').replace(/-/g, '/')
      || (thn.dataLayerHelper.get('startDate') || thn.dataLayerHelper.get('resFechaFin') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    const dateEnd = window.wbkEndDate?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') || (thn.dataLayerHelper.get('checkOutDate') || thn.dataLayerHelper.get('checkout_date') || '').replace(/-/g, '/')
      || (thn.dataLayerHelper.get('endDate') || thn.dataLayerHelper.get('resFechaIni') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }

    // Guests
    widgetData.adults = window.configuration?.guestList?.adults || thn.parseNumber(thn.dataLayerHelper.get('totalAdults') || thn.dataLayerHelper.get('busquedaTotalAdultos') || 2);
    widgetData.children = window.configuration?.guestList?.children || thn.parseNumber(thn.dataLayerHelper.get('totalChildren') || thn.dataLayerHelper.get('busquedaTotalNinos') || 0);
    widgetData.guests = widgetData.adults + widgetData.children;

    // Price & Currency fallback
    // On window.configuration we can obtain the price and the currency
    const priceFallback = window.configuration && window.configuration.cheapestBookableData && thn.objectGet(window.configuration.cheapestBookableData, 'cheapestRate');
    const currencyFallback = window.configuration && window.configuration.currency;

    // Prices & Currency
    // Witbooking could suggest other rooms that doesn't match the number of guests.
    // We should ensure we only get the prices of the wrapper that shows the rooms that matches the current room
    const priceSelector = thn.data.accountUserId === 1034881 ? '.dHnbaO .gmDRMD span:nth-child(1)' : '#inner_container > div:nth-child(1) .wbkv9-Amount-integerPart';
    let priceElements = document.querySelectorAll(priceSelector);

    if (thn.empty(priceElements)) {
      const containerPrices = document.querySelector('.EntityCarousel');
      priceElements = containerPrices?.querySelectorAll('[class*=Amount-integerPart]');
    }

    let prices = priceElements && [...priceElements].map((el) => {
      let price = el.textContent?.concat('.', el.nextSibling?.textContent);
      if (thn.data.accountUserId === 1034881) {
        price = el.textContent?.concat('.', el.nextSibling?.textContent);
      } else if (!document.querySelector('[class*="integer"]')) {
        price = price.replace(/(..)$/, '.$1');
      }
      return thn.parseNumber(price);
    }).filter(Boolean);

    let currency = document.querySelector('.wbkv9-Entity-amountCurrencyLabel, .wbkv9-InventoryRates-rateContainer div span')?.textContent?.match(/[A-Z]{3}/)?.toString() || document.querySelector('.dHnbaO span')?.textContent?.split('/')[0];

    // loyalty rates
    // Smart Rental Collection, Sand And Sea, Silken hotels
    const usersUsingLoyaltyRates = [1033906, 1035410].includes(thn.data.accountUserId);
    const propertiesUsingLoyaltyRates = [1037146, 1037147].includes(thn.data.propertyId);
    const shouldUseLoyaltyRates = usersUsingLoyaltyRates || propertiesUsingLoyaltyRates;

    if (shouldUseLoyaltyRates) {
      const loyaltyRatesInteger = document.querySelectorAll('#innerContainer span.sc-cTjmhe.fSXXhT span:nth-child(1)');
      prices = [...loyaltyRatesInteger].map((rate) => thn.parseNumber(rate.textContent?.concat('.', rate.nextSibling?.textContent))).filter(Boolean);
      currency = currencyFallback;
    }

    // On some versions, the classes are completely obfuscated
    let price;

    if (thn.empty(prices)) {
      price = thn.objectGet(window.dataLayer, 'cheapestRate', { first: false });
      if (!price) {
        prices = [...document.querySelectorAll('#innerContainer>div:nth-child(1) span > span > span:nth-child(1):not([class*=Footer])')].map((el) => thn.parseNumber(el.textContent)).filter(Boolean);
      }
      currency = (((document.querySelector('#innerContainer span > span > div') || {}).textContent || '').match(/[A-Z]{3}/) || []).toString();
    }

    if (price && currency) {
      widgetData.price = price;
      widgetData.currency = currency;
      widgetData.set = true;
    } else if (!thn.empty(prices) && currency) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = currency;
      widgetData.set = true;
    } else if (priceFallback && currencyFallback) {
      widgetData.price = priceFallback;
      widgetData.currency = currencyFallback;
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    try {
      // If a search has been applied for a room type, it is in the session storage with a value different from null.
      const isSpecialRoomRegExp = /inventoryTickersLikeFilter\W{2}[^null]/;
      const isSpecialURL = window.dataLayer.filter((item) => item.event === 'gtm.historyChange-v2').pop()?.['gtm.oldUrl'].includes('expand');
      const specialRoomStorageValue = window.sessionStorage.getItem('WB_WBV8-PROPERTY_ARI_REQUEST_PARAMS');
      const shouldChooseMultipleRoomsMsg = !!document.querySelector('#TOP_INVENTORY_STEP_1_OCCUPATION_MESSAGE');
      if (isSpecialRoomRegExp.test(specialRoomStorageValue) || thn.parseUrlParameter('expand') || isSpecialURL || shouldChooseMultipleRoomsMsg) {
        widgetData.priceSpecial = 1;
      }
    } catch (error) {
      ctx.widget.logger.debug(error);
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_1
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    if (!ctx.widget.isSet()) {

      const el = document.getElementsByTagName('body')[0];

      const thnObserveDomFunction = thn.debounce(function () {
        ctx.widget.logger.debug('*************** DOM Changed **************');
        if (ctx.widget.setData().isSet()) {
          ctx.widget.save();
          thn.stopObserveDom(el, thnObserveDomFunction);
        }
      }, 400);
      thn.observeDom(el, thnObserveDomFunction);
      thn.pageUnload(function () {
        thn.stopObserveDom(el, thnObserveDomFunction);
      });
    }
  };

  /**
     * Implements **bookingId**.
     *
     * @memberOf module:bs_1
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const transactionObject = window.transactionObject;

    if (document.querySelector && document.querySelector('.wbk-GlobalLoader-Loader, .wbk-Loader')) {

      widgetData.set = false;

    } else {

      if (window.dataLayer) {
        const promocode = thn.dataLayerHelper.get('transactionPromoCode');
        if (promocode) {
          widgetData.promocode = promocode;
        }
      }

      // Dates
      if (transactionObject && transactionObject.items && transactionObject.items[0].checkIn) {
        widgetData.dateBegin = transactionObject.items[0].checkIn.replace(/-/g, '/');
        widgetData.dateEnd = transactionObject.items[0].checkOut.replace(/-/g, '/');
      } else {
        const dates = document.querySelectorAll
          && Array.from(document.querySelectorAll('.wbk-ReservationConfirmed-card-price .wbk-ReservationConfirmed-row > div:first-child'))
            .filter(function (el) {
              return el.textContent.trim().match(/^[0-9-.]+$/);
            });
        if (dates && dates.length > 1) {
          widgetData.dateBegin = dates[0].textContent.trim().replace(/-/g, '/');
          widgetData.dateEnd = thn.dateToString(thn.addDays(dates[dates.length - 1].textContent.trim().replace(/-/g, '/'), 1));
        }
      }

      // Prices
      const dropdowns = document.querySelectorAll && document.querySelectorAll('.wbk-Menu-dropdownMenu > .wbk-Dropdown');
      if (dropdowns && dropdowns.length) {
        widgetData.currency = thn.getCurrencyCode(dropdowns[0].textContent.trim());
      }
      if (transactionObject && transactionObject.amount) {
        widgetData.price = transactionObject.amount;
        // legacy
        if (!widgetData.currency) {
          if (document.documentElement.textContent.match(/\(EUR\)/g) != null) { widgetData.currency = 'EUR'; } else if (document.documentElement.textContent.match(/\(USD\)/g) != null) { widgetData.currency = 'USD'; } else if (document.documentElement.textContent.match(/\(GBP\)/g) != null) { widgetData.currency = 'GBP'; }
        }
      } else {
        const prices = document.querySelectorAll && document.querySelectorAll('.wbk-ReservationConfirmed-card-price .wbk-ReservationConfirmed-row > div:last-child');
        if (prices && prices.length) {
          widgetData.price = Math.max(...Array.from(prices).map(function (el) {
            return thn.parseNumber(el.textContent);
          }));
        }
      }

      // bookingId
      if (transactionObject && transactionObject.items) {
        widgetData.bookingId = thn.objectGet(transactionObject.items, 'id');
      }

      let res;
      if (!widgetData.bookingId) {
        res = Array.from(document.querySelectorAll('div')).filter(function (el) {
          const copy = el.cloneNode(true);
          Array.from(copy.children || []).forEach(function (child) {
            try { child.remove(); } catch (e) {
              ctx.widget.logger.debug(e);
            }
          });
          return copy.textContent.match(/(reserva|r[ée]servation|buchung|réserve|riserva|Оговорка)(?!.*@)/i);
        });
        if (res.length && res[0].nextElementSibling) {
          widgetData.bookingId = res[0].nextElementSibling.textContent.trim();
        }
      }

      if (!widgetData.bookingId) {
        res = document.querySelector('.wbk-ReservationConfirmed-title + .wbk-ReservationConfirmed-row > div:last-child')
          || ((document.querySelector('[class*=BookingConfirmation-Reservations] > div > div > div > div > div > div') || {}).childNodes || [])[5]; // lots of random classes
        if (res) {
          widgetData.bookingId = (res.textContent || '').trim();
        }
      }

    }
    return widgetData;
  };

  /**
   * @memberOf module:bs_1
   * @this thn.widgets.price
   * @see {@link Price#getPromocode}
   *
   * @param {object} ctx - The context object.
   */
  engine.getPromocode = function getPromocode(ctx) {
    const promocode = thn.dataLayerHelper.get('promoCodes');
    if (promocode) {
      // Sometimes the promocode appears duplicated in the dataLayer,
      // so split method is used to get the first one.
      return promocode.split(',')[0];
    }
    return ctx;
  };

  return engine;

}

export { factory };
